import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'

import { Observable } from 'rxjs'

import {
  ENVIRONMENT_DEFINITION_PATH,
  FX_CLIENT_HOST,
  ORGANIZATION_DISCOVERY_PATH,
} from '@flowx/designer/modules/auth/auth.constants'
import {
  EnvironmentDefinition,
  OrganizationPublicInfo,
} from '@flowx/designer/modules/auth/auth.types'

import { ApiHttpService } from './api-http.service'

export interface ResendEmailVerificationPayload {
  orgId: string
  orgCode: string
}

@Injectable({
  providedIn: 'root',
})
export class AuthApiService extends ApiHttpService {
  constructor() {
    super(inject('BASE_URL' as any), inject(HttpClient))
  }

  getOrganizationPublicInfo(organizationName: string): Observable<OrganizationPublicInfo> {
    return this.get(`${ORGANIZATION_DISCOVERY_PATH}/${organizationName}`, {
      withCredentials: true,
      headers: {
        [FX_CLIENT_HOST]: window.location.hostname,
      },
    })
  }

  resendEmailVerification(payload: ResendEmailVerificationPayload): Observable<void> {
    return this.post(`org/api/org/resend-verification-email`, payload)
  }

  getEnvironmentDefinition(): Observable<EnvironmentDefinition> {
    return this.get(ENVIRONMENT_DEFINITION_PATH)
  }
}
